import { createAPIHeaders, fetchUtility } from '.';

export const getMessages = (topicName: string, key: string, apiKey: string): Promise<Response> => {
	return fetchUtility(`${import.meta.env.VITE_API_URL}/kafka/getAllMessages/${topicName}/${key}`, {
		headers: createAPIHeaders(apiKey, 'GET'),
		method: 'GET',
	});
};

export const getFileExists = (apiKey: string, containerName: string, fileName: string): Promise<Response> => {
	return fetchUtility(`${import.meta.env.VITE_API_URL}/azure/blobExists/${containerName}/${fileName}`, {
		headers: createAPIHeaders(apiKey, 'GET'),
		method: 'GET',
	});
};

export const getUploadSASUrl = (apiKey: string, containerName: string, fileName: string): Promise<Response> => {
	return fetchUtility(`${import.meta.env.VITE_API_URL}/azure/getUploadSASUrl/${containerName}/${fileName}`, {
		headers: createAPIHeaders(apiKey, 'GET'),
		method: 'GET',
	});
};

export const getDownloadSASUrl = (apiKey: string, containerName: string, fileName: string): Promise<Response> => {
	return fetchUtility(`${import.meta.env.VITE_API_URL}/azure/getDownloadSASUrl/${containerName}/${fileName}`, {
		headers: createAPIHeaders(apiKey, 'GET'),
		method: 'GET',
	});
};

export const getKeyphraseFiles = async (apiKey: string, pipelineName: string): Promise<Response> => {
	return fetchUtility(`${import.meta.env.VITE_API_URL}/eks/getKeywordFiles/${pipelineName}`, {
		headers: createAPIHeaders(apiKey, 'GET'),
		method: 'GET',
	});
};

export const getAllKeyphraseFiles = async (apiKey: string): Promise<Response> => {
	return fetchUtility(`${import.meta.env.VITE_API_URL}/eks/getAllKeywordFiles`, {
		headers: createAPIHeaders(apiKey, 'GET'),
		method: 'GET',
	});
};

export const checkOperationExists = async (apiKey: string, operationName: string): Promise<Response> => {
	return fetchUtility(`${import.meta.env.VITE_API_URL}/users/operationExists/${operationName}`, {
		headers: createAPIHeaders(apiKey, 'GET'),
		method: 'GET',
	});
};

export const getAllOperations = async (apiKey: string): Promise<Response> => {
	return fetchUtility(`${import.meta.env.VITE_API_URL}/users/allRoles`, {
		headers: createAPIHeaders(apiKey, 'GET'),
		method: 'GET',
	});
};

export const getUpdateNotice = async (apiKey: string): Promise<Response> => {
	return fetchUtility(`${import.meta.env.VITE_API_URL}/app/updateNotice`, {
		headers: createAPIHeaders(apiKey, 'GET'),
		method: 'GET',
	});
};

export const getFAQs = async (apiKey: string): Promise<Response> => {
	return fetchUtility(`${import.meta.env.VITE_API_URL}/app/faqs`, {
		headers: createAPIHeaders(apiKey, 'GET'),
		method: 'GET',
	});
};

export const getDisabledTabs = async (apiKey: string): Promise<Response> => {
	return fetchUtility(`${import.meta.env.VITE_API_URL}/app/disabledTabs`, {
		headers: createAPIHeaders(apiKey, 'GET'),
		method: 'GET',
	});
};

export const getOrganizationRoles = async (apiKey: string): Promise<Response> => {
	return fetchUtility(`${import.meta.env.VITE_API_URL}/users/organizationRoles`, {
		headers: createAPIHeaders(apiKey, 'GET'),
		method: 'GET',
	});
};

export const getForceDetails = async (apiKey: string): Promise<Response> => {
	return fetchUtility(`${import.meta.env.VITE_API_URL}/eks/forceDetails`, {
		headers: createAPIHeaders(apiKey, 'GET'),
		method: 'GET',
	});
};

export const getAllLEAs = async (apiKey: string): Promise<Response> => {
	return fetchUtility(`${import.meta.env.VITE_API_URL}/users/allLEAs`, {
		headers: createAPIHeaders(apiKey, 'GET'),
		method: 'GET',
	});
};

export const getAdminUsers = async (apiKey: string): Promise<Response> => {
	return fetchUtility(`${import.meta.env.VITE_API_URL}/users/allUsers`, {
		headers: createAPIHeaders(apiKey, 'GET'),
		method: 'GET',
	});
};

export const getAllOrganisations = async (apiKey: string): Promise<Response> => {
	return fetchUtility(`${import.meta.env.VITE_API_URL}/users/allOrganisations`, {
		headers: createAPIHeaders(apiKey, 'GET'),
		method: 'GET',
	});
};

export const getChatThread = async (
	apiKey: string,
	caseRef: string,
	chatId: string,
	page: string | null,
	pipelineType: string,
	messageId?: string | null
): Promise<Response> => {
	let reqUrl = `${import.meta.env.VITE_API_URL}/chat/getThread/${pipelineType}/${caseRef}/${chatId}`;
	const urlParams = new URLSearchParams();
	if (page) {
		urlParams.append('page', page);
	}
	if (messageId) {
		urlParams.append('messageId', messageId);
	}

	if (urlParams.size > 0) {
		reqUrl += `?${urlParams}`;
	}

	return fetchUtility(reqUrl, {
		headers: createAPIHeaders(apiKey, 'GET'),
		method: 'GET',
	});
};

export const getAllParticipants = async (apiKey: string, caseRef: string, chatId: string, pipelineType: string): Promise<Response> => {
	return fetchUtility(`${import.meta.env.VITE_API_URL}/chat/getAllParticipants/${pipelineType}/${caseRef}/${chatId}`, {
		headers: createAPIHeaders(apiKey, 'GET'),
		method: 'GET',
	});
};

export const getMetricsFilterOptions = async (apiKey: string): Promise<Response> => {
	return fetchUtility(`${import.meta.env.VITE_API_URL}/users/metricsFilterOptions`, {
		headers: createAPIHeaders(apiKey, 'GET'),
		method: 'GET',
	});
};

export const getOrganisationUsers = async (
	apiKey: string,
	organisationId: string,
	includeOrgRoles?: boolean,
	includeAllDetails?: boolean
): Promise<Response> => {
	let reqUrl = `${import.meta.env.VITE_API_URL}/users/getOrganisationUsers/${organisationId}`;
	const urlParams = new URLSearchParams();
	if (includeOrgRoles) {
		urlParams.append('includeOrgRoles', 'true');
	}
	if (includeAllDetails) {
		urlParams.append('includeAllDetails', 'true');
	}

	if (urlParams.size > 0) {
		reqUrl += `?${urlParams}`;
	}

	return fetchUtility(reqUrl, {
		headers: createAPIHeaders(apiKey, 'GET'),
		method: 'GET',
	});
};
